import { createContext, useContext } from 'react'
import { OutboundScheduleShipperCode } from '../types/query'

// LOGISPRD-12495 — 허용 화주로 확정된 화주코드. index.tsx 가 확정한 뒤에만 Provider 로 그리드를 연다.
const ScheduleShipperContext = createContext<OutboundScheduleShipperCode | null>(null)

export const useScheduleShipperCode = (): OutboundScheduleShipperCode => {
  const shipperCode = useContext(ScheduleShipperContext)

  // MUSINSA 같은 기본값으로 떨어뜨리면 허용 밖 화주로 조회·저장이 나간다 — 조용히 넘기지 않는다
  if (!shipperCode) {
    throw new Error('useScheduleShipperCode must be used within a ScheduleShipperProvider')
  }

  return shipperCode
}

export const ScheduleShipperProvider = ({ children, shipperCode }: { children: React.ReactNode; shipperCode: OutboundScheduleShipperCode }) => {
  return <ScheduleShipperContext.Provider value={shipperCode}>{children}</ScheduleShipperContext.Provider>
}
